<template>
  <Drawer
    width="400"
    :title="`${openedSales ? '编辑' : '新增'}销售记录`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="客户" prop="customer" style="width: 366px">
          <Select
            v-model="formItem.customer"
            filterable
            remote
            style="width: 366px"
            :remote-method="remoteMethod"
            :loading="customerLoading"
            placeholder="请填写客户名字后选择"
          >
            <Option
              v-for="option in customerList"
              :value="option._id"
              :key="option._id"
              style="width: 366px"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="内容" prop="content">
          <Input
            v-model="formItem.content"
            type="textarea"
            show-word-limit
            :rows="6"
            maxlength="200"
            placeholder="在此填写销售记录..."
          />
        </FormItem>
        <!-- 标签选择 -->
        <FormItem label="销售标签" prop="tag">
          <Select
            v-model="formItem.tags"
            multiple
            filterable
            :remote-method="remoteTagsMethod"
            :loading="tagLoading"
          >
            <Option
              v-for="option in tagsList"
              :value="option.value"
              :key="option.value"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateSalesDrawer",
  data() {
    return {
      drawerOpened: false,
      type: null,
      openedSales: null,
      customerLoading: false,
      tagLoading: false,
      productList: [],
      formItem: {
        customer: null,
        content: null,
        tags: null,
      },
      ruleValidate: {
        customer: [
          { required: true, message: "名字为必填项", trigger: "submit" },
        ],
        content: [
          {
            required: true,
            message: "销售记录内容为必填项",
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      customerList: (state) => state.customer.customers,
      tagsList: (state) => state.salesRecord.salesRecordTags,
    }),
  },
  methods: {
    ...mapActions({
      createSalesRecord: "salesRecord/createSalesRecordAction",
      updateSalesRecord: "salesRecord/updateSalesRecordAction",
      getCustomers: "customer/getCustomersAction",
      getSalesRecordTags: "salesRecord/getSalesRecordTagsAction",
    }),
    async remoteMethod(query) {
      if (query !== "") {
        this.customerLoading = true;
        await this.getCustomers({ limit: 15, name: query });
        this.customerLoading = false;
      }
    },
    // 获取标签
    remoteTagsMethod(query) {
      if (query !== "") {
        this.tagLoading = true;
      }
    },
    async openDrawer(salesRecord) {
      this.$refs["formItem"].resetFields();
      this.openedSales = salesRecord; // 如果有打开，则为编辑模式
      if (salesRecord) {
        this.formItem.content = salesRecord.content;
        this.formItem.customer = salesRecord.customer._id;
        this.formItem.tags = salesRecord.tags;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSales) {
              await this.updateSalesRecord({
                id: this.openedSales._id,
                data: this.formItem,
              });
            } else {
              await this.createSalesRecord(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
  async created() {
    await this.getSalesRecordTags();
  },
};
</script>
<style scoped lang="stylus"></style>